module.exports = __webpack_public_path__ + "static/media/СЗФО_94.f9583f4c.png";